import z from "zod";
import { minErrorMsg } from "./minErrorMsg";

export const setZodErrorMap = (zod: typeof z) => {
  zod.setErrorMap((issue, ctx) => {
  // Customize the error message based on the issue code
  switch (issue.code) {
    case z.ZodIssueCode.too_small:
      return minErrorMsg(issue.minimum)();
    default:
      return { message: ctx.defaultError };
  }
});
}
